import { gql } from '@apollo/client';

export const createConferenceQuery = gql`
  mutation createConference($input: InputCreateConference!) {
    createConference(input: $input)
  }
`;
